import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./dashboardmain.css";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import axios from "../../axios/axios";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { Card, CardBody, Input } from "reactstrap";
import { H4 } from "../../AbstractElements";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { MdOutlineCancel } from "react-icons/md";
import { GoIssueClosed } from "react-icons/go";
import { IoAlertCircleOutline, IoLockClosedOutline } from "react-icons/io5";
import CountUp from "react-countup";
import { FaWhatsapp } from "react-icons/fa";
import { toast } from "react-toastify";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const Dashboardmain = () => {
  const navigate = useNavigate();
  const baseurl = useSelector((store) => store.baseUrl);
  const AUTHORIZE_KEY = "c34FxCQy4DCGCHA9zlTgqTsywZJSW8hy";
  const componentRef = useRef();
  const image_url_logo = localStorage.getItem("company_logo_pos");
  const [searchtext, setSearchtext] = useState("");
  const [invoiceData, setInvoiceData] = useState([]);
  const [filteredinvoiceData, setFilteredInvoiceData] = useState([]);
  const [data_info, setDatainfo] = useState("");
  const [invoiceinfo, setInvoiceinfo] = useState({});
  const [currentInvoice, setCurrentInvoice] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleComposeButtonClick = () => {
    navigate(`${process.env.PUBLIC_URL}/dashboardpos`);
  };

  const invoiceColumns = [
    {
      name: "Invoice No.",
      selector: (row) => row?.No, // Adjust to match your data structure
      sortable: true,
      center: true,
      minWidth: "100px",
    },
    {
      name: "Date",
      selector: (row) => row?.Date, // Adjust to match your data structure
      sortable: true,
      center: true,
      minWidth: "80px",
    },
    {
      name: "Contacts",
      selector: (row) => (
        <>
          <div
            style={{
              textAlign: "start",
              overflow: "hidden",
              whiteSpace: "normal",
            }}
          >
            {row?.Name.replace(/\+/g, " ")}
          </div>
        </>
      ),
      sortable: true,
      center: true,
      minWidth: "220px",
      // sortable: true,
    },
    {
      name: "Mobile Number",
      selector: (row) => row?.Mobile, // Replace '+' with a space in the Name property
      sortable: true,
      center: true,
      // minWidth: "100px",
      width: "150px",
    },
    {
      name: "Amount",
      selector: (row) => (
        <div>
          ₹ {row.Amount} {/* Add the Rupees icon before the Amount */}
        </div>
      ), // Adjust to match your data structure
      sortable: true,
      center: true,
      minWidth: "100px",
    },
    {
      name: "Share",
      cell: (row) => (
        <button
          onClick={() => handleWhatsAppClick(row)}
          disabled={isLoading}
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            color: isLoading 
              ? "#ccc" 
              : row.create_from == 0 
                ? "#FFF" 
                : row.create_from == 1 
                  ? "#26994e" 
                  : "#26994e", // Default color if create_from is neither 0 nor 1
            fontSize: "24px",
          }}
          title="Send via WhatsApp"
        >
          <FaWhatsapp />
        </button>
      ),
      center: true,
      minWidth: "80px",
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }
  ];

  //Added by Akshar for Background Color for TR
  // Define conditional row styles
const conditionalRowStyles = [
  {
    when: (row) => row.create_from == 0, // Condition for create_from: 0
    style: {
      backgroundColor: "#007c41 !important", // Light red background (or any color you prefer)
      color: "#fff !important", // Darker text color for contrast
    },
  },
  {
    when: (row) => row.create_from == 1, // Condition for create_from: 1
    style: {
      backgroundColor: "#f5f4ef !important", // Light green background (or any color you prefer)
      color: "#098048 !important", // Darker text color for contrast
    },
  },
];


  // Format API response to match template structure
  const formatInvoiceData = (apiData) => ({
    ...apiData,
    Invoice_fullno: apiData.fullinvoiceno,
    contact_name: apiData.contact_name,
    contact_number: apiData.mobile_no,
    currenttodaydate: apiData.invoice_dt,
    cart: apiData.products.map((product) => ({
      product_id: product.id || Math.random().toString(36).substr(2, 9),
      name: product.name,
      quantity: product.quantity,
      subT: product.price * product.quantity,
      price: product.price,
    })),
    billSummary: {
      actualTotalPrice: apiData.total_amount,
      totalDiscount: apiData.total_discount,
      totalTaxes: apiData.total_tax,
      grandTotal: apiData.grand_total,
    },
  });

  // Fetch invoice data from API
  const fetchInvoiceData = async (invoiceId) => {
    try {
      const formData = new FormData();
      formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
      formData.append("PHPTOKEN", localStorage.getItem("id_token"));
      formData.append("invoice_id", invoiceId);

      const response = await fetch(
        `${baseurl}/expo_access_api/getInvoiceProductData/`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      if (result?.STATUS === "SUCCESS" && result?.DATA) {
        return formatInvoiceData(result?.DATA);
      }
      throw new Error("Failed to fetch invoice data");
    } catch (error) {
      console.error("Fetch error:", error);
      throw error;
    }
  };

  // Handle WhatsApp click
  const handleWhatsAppClick = async (row) => {
    try {
      setIsLoading(true);
      const data = await fetchInvoiceData(row?.ID);
      // Pass data directly to generatePDF instead of setting state
      await generatePDF(data);
    } catch (error) {
      toast.error(error.message || "Error processing invoice", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Generate PDF and send to WhatsApp (now accepts invoiceData parameter)
  const generatePDF = async (invoiceData) => {
    if (!invoiceData) return;

    // Declare originalStyles at the function level
    let originalStyles = {};

    try {
      setIsLoading(true);
      window.html2canvas = html2canvas;

      // Temporarily set currentInvoice for the PDF generation
      setCurrentInvoice(invoiceData);

      // Get the invoice element before making changes
      const element = document.querySelector("#rep1");

      // Store original styles
      originalStyles = {
        position: element.style.position,
        left: element.style.left,
        top: element.style.top,
        visibility: element.style.visibility,
      };

      // Move element off-screen instead of hiding
      element.style.position = "absolute";
      element.style.left = "-9999px";
      element.style.visibility = "visible";

      // Give React time to update the DOM with the invoice data
      await new Promise((resolve) => setTimeout(resolve, 150));

      // Create a new jsPDF instance in portrait mode
      const pdf = new jsPDF("p", "mm", "a4");

      // Use html2canvas with optimized settings
      const canvas = await html2canvas(element, {
        scale: 2,
        logging: false,
        useCORS: true,
        allowTaint: true,
        width: element.scrollWidth,
        height: element.scrollHeight,
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight,
      });

      // Calculate image dimensions to fill the page
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pdfWidth - 10;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Add image to PDF
      pdf.addImage(canvas, "PNG", 5, 5, imgWidth, imgHeight, undefined, "FAST");

      // Create blob from PDF
      const blobPDF = new Blob([pdf.output("blob")], {
        type: "application/pdf",
      });

      // Send the PDF
      await sendPDFToWhatsApp(blobPDF, invoiceData);
      setCurrentInvoice(null);
    } catch (error) {
      console.error("PDF generation error:", error);
      toast.error("Error generating PDF", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      // Restore original styles
      const element = document.querySelector("#rep1");
      if (element) {
        element.style.position = originalStyles.position || "";
        element.style.left = originalStyles.left || "";
        element.style.top = originalStyles.top || "";
        element.style.visibility = originalStyles.visibility || "hidden";
      }
      setIsLoading(false);
    }
  };

  // Send PDF to WhatsApp API (now accepts invoiceData parameter)
  const sendPDFToWhatsApp = async (pdfBlob, invoiceData) => {
    try {
      const message = `Hi ${invoiceData.contact_name}, Attached is your invoice. Let me know if you need anything else.`;
      const formData = new FormData();
      formData.append("image", pdfBlob);
      formData.append("invoice_id", invoiceData.invoice_id);
      formData.append("contact_id", invoiceData.contact_id);
      formData.append("countrycode", 91);
      formData.append("mobileno", invoiceData.contact_number);
      formData.append("wp_clientmsg", message);
      formData.append("contactType", invoiceData.type);
      formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
      formData.append("PHPTOKEN", localStorage.getItem("id_token"));

      const response = await fetch(
        `${baseurl}/expo_access_api/invoicePdfsendfdtowhatsapp/`,
        { method: "POST", body: formData }
      );

      if (!response.ok) throw new Error("Failed to send PDF");

      toast.success("Invoice sent successfully!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } catch (error) {
      console.error("WhatsApp send error:", error);
      throw error;
    }
  };

  useEffect(() => {
    const postData = async () => {
      try {
        const res = await axios.post("/expo_access_api/getTransactionList", {
          AUTHORIZEKEY: "c34FxCQy4DCGCHA9zlTgqTsywZJSW8hy",
        });

        const { data } = res;

        if (data && data[0]?.DATA?.invoiceList) {
          const message = data[0].MSG;
          setDatainfo(message);
          setInvoiceData(res?.data[0]?.DATA?.invoiceList);
          setFilteredInvoiceData(res?.data[0]?.DATA?.invoiceList);
          setInvoiceinfo(res?.data[0]?.DATA);
        } else {
          const message = data[0].MSG;
          setDatainfo(message);
          setInvoiceData([]);
          setFilteredInvoiceData([]);
          setInvoiceinfo({});
        }
      } catch (error) {
        console.error("Error posting data:", error);
        // You might want to display an error message to the user here
      }
    };

    postData();
  }, []);

  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchtext(searchValue);

    const filteredItems = invoiceData.filter((item) => {
      return Object.keys(item).some((key) => {
        if (item[key] && typeof item[key] === "string") {
          const cleanedItem = item[key]
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "") // Remove special characters
            .replace(/\s+/g, " ") // Replace multiple spaces with a single space
            .trim();
          const cleanedSearchValue = searchValue
            .replace(/[^a-z0-9]+/g, "") // Remove special characters
            .replace(/\s+/g, " ") // Replace multiple spaces with a single space
            .trim();

          return cleanedItem.includes(cleanedSearchValue);
        }
        return false;
      });
    });

    setFilteredInvoiceData(filteredItems);
  };

  // const paginationOptions = {
  //   rowsPerPageText: "Rows per page:",
  //   rangeSeparatorText: "of",
  //   selectAllRowsItem: true,
  //   selectAllRowsItemText: "All",
  // };

  return (
    <>
      <div className="dashboardposmain">
        <div className="grid-container-dashboard ">
          <Col>
            {/* <Widgets1 data={Widgets2Data} />  */}
            <Card className="widget-1">
              <CardBody>
                <div className="widget-content">
                  <div className={`widget-round primary`}>
                    <div className="bg-round">
                      {/* <SvgIcon className='svg-fill' iconId={`${data.icon}`} /> */}
                      {/* <SvgIcon className='half-circle svg-fill' iconId='halfcircle' /> */}
                      <LiaFileInvoiceSolid color="#7366ff" />
                    </div>
                  </div>
                  <div>
                    <H4>
                      <CountUp
                        prefix=""
                        duration={3}
                        start={0}
                        separator=","
                        end={invoiceinfo?.total_invoice}
                      />
                    </H4>
                    {/* <H4>{invoiceinfo?.total_invoice}</H4> */}
                    <span className="f-light">Invoice</span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col>
            {/* <Widgets1 data={WidgetsData} />  */}
            <Card className="widget-1">
              <CardBody>
                <div className="widget-content">
                  <div className={`widget-round warning`}>
                    <div className="bg-round">
                      {/* <SvgIcon className='svg-fill' iconId={`cart`} />
              <SvgIcon className='half-circle svg-fill' iconId='halfcircle' /> */}
                      <MdOutlineCancel color="#ffaa05" />
                    </div>
                  </div>
                  <div>
                    <H4>
                      <CountUp
                        prefix=""
                        duration={3}
                        start={0}
                        separator=","
                        end={invoiceinfo?.cancel_invoice}
                      />
                    </H4>
                    {/* <H4>{invoiceinfo?.cancel_invoice}</H4> */}
                    <span className="f-light">Cancel Orders</span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col>
            {/* <Widgets1 data={WidgetsData3} />  */}
            <Card className="widget-1">
              <CardBody>
                <div className="widget-content">
                  <div className={`widget-round secondary`}>
                    <div className="bg-round">
                      {/* <SvgIcon className='svg-fill' iconId={`cart`} />
              <SvgIcon className='half-circle svg-fill' iconId='halfcircle' /> */}
                      <IoLockClosedOutline color="#d63384" />
                    </div>
                  </div>
                  <div>
                    <H4>
                      <CountUp
                        prefix=""
                        duration={3}
                        start={0}
                        separator=","
                        end={invoiceinfo?.close_invoice}
                      />
                    </H4>
                    {/* <H4>{invoiceinfo?.close_invoice}</H4> */}
                    <span className="f-light">Close Orders</span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col>
            {/* <Widgets1 data={Widgets2Data} />  */}
            <Card className="widget-1">
              <CardBody>
                <div className="widget-content">
                  <div className={`widget-round success`}>
                    <div className="bg-round">
                      {/* <SvgIcon className='svg-fill' iconId={`${data.icon}`} /> */}
                      {/* <SvgIcon className='half-circle svg-fill' iconId='halfcircle' /> */}
                      <GoIssueClosed color="#54ba4a" />
                    </div>
                  </div>
                  <div>
                    <H4>
                      <CountUp
                        prefix=""
                        duration={3}
                        start={0}
                        separator=","
                        end={invoiceinfo?.paid_invoice}
                      />
                    </H4>
                    {/* <H4>{invoiceinfo?.paid_invoice}</H4> */}
                    <span className="f-light">Paid Orders</span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          {/* <Col>
          <Widgets1 data={Widgets2Data} /> 
          <Card className="widget-1">
            <CardBody>
              <div className="widget-content">
                <div className={`widget-round unpaid`}>
                  <div className="bg-round">
                    <SvgIcon className='svg-fill' iconId={`${data.icon}`} />
                    <SvgIcon className='half-circle svg-fill' iconId='halfcircle' />
                    <IoAlertCircleOutline size={40} color="#dc3545" />
                  </div>
                </div>
                <div>
                <H4><CountUp prefix='' duration={3} start={0} separator=',' end={invoiceinfo?.unpaid_invoice} /></H4> 
                  <span className="f-light">Unpaid Orders</span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col> */}
        </div>

        <Row>
          <Col sm="12">
            <Card>
              {/* <HeaderCard title="Select Multiple and Delete Single Data" /> */}
              {/* Loading indicator */}
              
              
              {isLoading && (
                <div className="text-center timesheet-label mt-3">
                  Please wait while sending the invoice...
                </div>
              )}
              <CardBody>
  {/* Always show Create Invoice button at the top-right */}
  <div className="d-flex justify-content-between align-items-center mb-3">
    <div style={{ width: '200px' }}></div> {/* Empty spacer to balance the flex layout */}
    <div className="export-new">
      <Button
        className="searchbtn"
        onClick={handleComposeButtonClick}
      >
        Create Invoice
      </Button>
    </div>
  </div>

  {/* Conditional content */}
  {data_info == "Data Not Found" ? (
    <div
      className="text-center mt-3 py-3"
      style={{ backgroundColor: "#dfdcdc" }}
    >
      No Records found
    </div>
  ) : invoiceData.length == 0 ? (
    <div className="text-center mt-3">
      <Spinner animation="border" variant="success" />
    </div>
  ) : (
    <div className="datatable-dashboardposmain my-2">
      <div className="d-flex justify-content-between mb-3">
        <div>
          <Input
            className="form-control register-full input-register"
            type="text"
            placeholder="Search..."
            value={searchtext}
            onChange={handleSearch}
          />
        </div>
      </div>

      <DataTable
        data={filteredinvoiceData}
        columns={invoiceColumns}
        striped={true}
        center={true}
        pagination
        conditionalRowStyles={conditionalRowStyles}
      />
    </div>
  )}

  {/* Optional: Add another Create Invoice button at the bottom if desired */}
  {/* <div className="export-new text-end mt-3">
    <Button
      className="searchbtn"
      onClick={handleComposeButtonClick}
    >
      Create Invoice
    </Button>
  </div> */}
</CardBody>
              {isLoading && (
                <div className="text-center timesheet-label mb-3">
                  Please wait while sending the invoice...
                </div>
              )}
            </Card>
          </Col>
        </Row>
      </div>

      {/* style={{ height: 0, overflow: "hidden", visibility: "hidden" }} */}
      {/* Hidden invoice template */}
      <div>
        <div
          className="d-flex justify-content-center align-items-center"
          ref={componentRef}
          id="rep1"
          style={{
            width: "210mm", // Matches A4 width
            minHeight: "auto",
            padding: "20px",
            backgroundColor: "white",
            boxSizing: "border-box",
            visibility: "hidden", // Initially hidden
            position: "absolute", // Take out of document flow
          }}
        >
          <div className="receipt" style={{ width: "100%", height: "100%" }}>
            <div className="text-center">
              <img
                src={`${baseurl}${image_url_logo}`}
                alt="Company Logo"
                className="img-fluid for-light my-2"
              />
            </div>

            <p>
              <b>Name:</b> {currentInvoice?.contact_name || "Cash Contact"}
            </p>
            <p>
              <b>Mobile:</b> {currentInvoice?.contact_number || "9824023886"}
            </p>
            <hr className="my-2" />
            <p>
              <b>Invoice No:</b> {currentInvoice?.Invoice_fullno}
            </p>
            <p>
              <b>Date:</b> {currentInvoice?.currenttodaydate}
            </p>
            <hr className="my-2" />

            <table className="invoice-products">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Qty</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {currentInvoice?.cart?.map((item) => (
                  <tr key={item?.product_id || Math.random()}>
                    <td>{item?.name}</td>
                    <td>{item?.quantity}</td>
                    <td>
                      <span className="inr-font">INR </span>
                      {item?.price?.toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan="2">Total Gross Amount</th>
                  <td>
                    <span className="inr-font">INR </span>
                    {currentInvoice?.billSummary?.actualTotalPrice}
                  </td>
                </tr>
                <tr>
                  <th colSpan="2">Total Discount Amount</th>
                  <td>
                    <span className="inr-font">INR </span>
                    {currentInvoice?.billSummary?.totalDiscount}
                  </td>
                </tr>
                <tr>
                  <th colSpan="2">Total Taxes Amount</th>
                  <td>
                    <span className="inr-font">INR </span>
                    {currentInvoice?.billSummary?.totalTaxes}
                  </td>
                </tr>
                <tr>
                  <th colSpan="2">Total Payable Amount</th>
                  <td>
                    <span className="inr-font">INR </span>
                    {currentInvoice?.billSummary?.grandTotal?.toFixed(2)}
                  </td>
                </tr>
              </tfoot>
            </table>

            <hr className="my-2" />
            <p>Thank you for your business!</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboardmain;
